<template>
  <transition name="fade">
    <div :class="'alert_'+type" v-if="visible">    
    <div class="message "  :class="type" v-if="visible">
      <div class="content">
        <i class="icon-icon" :class="'uk-icon-'+type"></i>
        {{content}}
        <i v-if="hasClose" class="uk-icon uk-icon-close" @click="visible=false"></i>
      </div>
    </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "message",
    data() {
      return {
        content: '',
        time: 3000,        
        success_time: 1000,        

        visible: false,
        type:'check',//'check','warning','close'
        hasClose:false,
      }
    },
    mounted() {
      this.close(this.type)
    },
    methods: {
      close(v) {
        if(v == 'check'){
             window.setTimeout(() =>{
                this.visible = false
              }, this.success_time);
        }else{
             window.setTimeout(() =>{
                this.visible = false
              }, this.time);
        }  
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/message/message.vue